import { createSelector } from "reselect";

export const isLoadingNotifications = (state) =>
  state.softwareNotification?.loadingNotifications;

export const selectNotifications = (state) =>
  state.softwareNotification?.notifications || [];

export const selectSoftwareNotificationById = createSelector(
  [(state, props) => props.identifier, selectNotifications],
  (notificationId, softwareNotifications) => {
    if (!softwareNotifications || softwareNotifications.length === 0)
      return null;
    if (!notificationId) return undefined;
    return softwareNotifications.find(
      (notification) => notification.id === notificationId,
    );
  },
);
